$(document).ready(function () {

    var locations = [],
        defaultLat = 46.6217167,/* Point centrale France*/
        defaultLong = 1.8141639,
        markers = [],
        franceMarkers = [],
        geocoder = new google.maps.Geocoder(),
        infoWindow = "",
        style = [{
            "featureType": "administrative",
            "elementType": "all",
            "stylers": [{"saturation": "-100"}]
        }, {
            "featureType": "administrative.province",
            "elementType": "all",
            "stylers": [{"visibility": "off"}]
        }, {
            "featureType": "landscape",
            "elementType": "all",
            "stylers": [{"saturation": -100}, {"lightness": 65}, {"visibility": "on"}]
        }, {
            "featureType": "poi",
            "elementType": "all",
            "stylers": [{"saturation": -100}, {"lightness": "50"}, {"visibility": "simplified"}]
        }, {
            "featureType": "road",
            "elementType": "all",
            "stylers": [{"saturation": "-100"}]
        }, {
            "featureType": "road.highway",
            "elementType": "all",
            "stylers": [{"visibility": "simplified"}]
        }, {
            "featureType": "road.arterial",
            "elementType": "all",
            "stylers": [{"lightness": "30"}]
        }, {
            "featureType": "road.local",
            "elementType": "all",
            "stylers": [{"lightness": "40"}]
        }, {
            "featureType": "transit",
            "elementType": "all",
            "stylers": [{"saturation": -100}, {"visibility": "simplified"}]
        }, {
            "featureType": "water",
            "elementType": "geometry",
            "stylers": [{"hue": "#ffff00"}, {"lightness": -25}, {"saturation": -97}]
        }, {"featureType": "water", "elementType": "labels", "stylers": [{"lightness": -25}, {"saturation": -100}]}];


    // Get every job offers and push it into "locations" object
    allMarkers.forEach((marker, index) => {

        if (marker.address === "" || marker.address === '_default') {

            marker.address = 'France';
            marker.latitude = defaultLat;
            marker.longitude = defaultLong;
        }

        if (marker.latitude === "" && marker.longitude === "") {

            geocoder.geocode({'address': marker.address}, function (results, status) {

                if (status === google.maps.GeocoderStatus.OK) {

                    marker.latitude = results[0].geometry.location.lat();
                    marker.longitude = results[0].geometry.location.lng();

                } else {

                    marker.latitude = defaultLat;
                    marker.longitude = defaultLong;

                }

            });
        }

        locations.push(marker);
    });

    var i = 0;

    // If section exists in HTML, init Google map
    if (document.body.contains(document.getElementById('nos-offres-odoo-map'))) {
        var latlng = new google.maps.LatLng(defaultLat, defaultLong);
        var map = new google.maps.Map(document.getElementById('nos-offres-odoo-map'), {
            center: latlng,
            zoom: 5,
            minZoom: 5,
            maxZoom: 15,
            mapTypeId: 'roadmap',
            mapTypeControlOptions: {style: google.maps.MapTypeControlStyle.DROPDOWN_MENU},
            styles: style
        });
    }


    // Init info bubble
    var infoWindow = new google.maps.InfoWindow();

    $('#zipCodeInput').keypress(function (e) {
        var code = e.keyCode ? e.keyCode : e.which;
        if (code.toString() == 13)
            searchLocations();
    });

    $(document).on('click', 'span.search_locations', function (e) {
        e.preventDefault();
        searchLocations();
    });

    google.maps.event.addDomListener(window, "resize", function () {
        var map_center = map.getCenter();
        google.maps.event.trigger(map, "resize");
        map.setCenter(map_center);
    });

    if (typeof ($(".select-multiple")) !== "undefined") {

        $(".select-multiple").select2({
            placeholder: "-- Localité --",
            multiple: true,
        }).on('select2:open', function(e) {
            setTimeout(function () {
                $(".select2-container--open .select2-results__option").addClass("select2_region");
                $(".select2-container--open").find('li[data-select2-id$="0"], li[data-select2-id$="1"], li[data-select2-id$="2"], li[data-select2-id$="3"], li[data-select2-id$="4"], li[data-select2-id$="5"], li[data-select2-id$="6"], li[data-select2-id$="7"], li[data-select2-id$="8"], li[data-select2-id$="9"]').removeClass("select2_region");
            }, 10);
        });

        // Récupère sous forme de tableau les valeurs selectionnées
        $(".select-multiple").on("change", function () {
            var selector_value = $(this).val();
            $("#id_location").val(selector_value);
        });

    }

    /* Waiting for Google results before init */
    if (typeof map !== "undefined") {
        setTimeout(function () {
            initMarkers();
        }, 1500);
    }


    function getUrlParameter(sParam) {
        var sPageURL = window.location.search.substring(1),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;

        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');

            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
            }
        }
    };

    // Create markers and clusters on map
    function initMarkers() {

        var site_url = location.protocol + "//" + location.host;
        if (window.location.href.indexOf("/wordpress/") > -1) {
            site_url = location.protocol + "//" + location.host + "/wordpress";
        }

        var bounds = new google.maps.LatLngBounds();
        // Check if locations array exists and not empty
        if (typeof (locations) !== "undefined" && locations.length !== 0) {

            // First, create a marker for each offer in "locations" array
            for (var i = 0; i < locations.length; i++) {
                if (typeof (locations[i].latitude) !== "undefined" && typeof (locations[i].longitude) !== "undefined") {
                    var name = locations[i].title;
                    var address = locations[i].address;
                    var addressNoHtml = locations[i].address;
                    var link = locations[i].link;

                    var latlng = new google.maps.LatLng(
                        parseFloat(locations[i].latitude),
                        parseFloat(locations[i].longitude));

                    if (address === "_default") {
                        latlng = new google.maps.LatLng(
                            parseFloat(46.6217167),
                            parseFloat(1.8141639)
                        );
                    }

                    createMarker(latlng, name, address, link);

                    bounds.extend(latlng);
                }
            }

            // Create clusters for close or same place markers
            var markerCluster = new MarkerClusterer(map, markers, {
                imagePath: site_url + "/wp-content/themes/alpes-controles-child/www/images/google-maps/m",
                gridSize: 20,
                minimumClusterSize: 2
                // maxZoom: 14,
                // zoomOnClick: false
            });

            const franceMarkerCluster = new MarkerClusterer(map, franceMarkers, {
                imagePath: site_url + "/wp-content/themes/alpes-controles-child/www/images/google-maps/franceMarker",
                zoomOnClick: false,
                styles: [{
                    url: site_url + "/wp-content/themes/alpes-controles-child/www/images/google-maps/franceMarker1.png",
                    textColor: "#FFFFFF",
                    width: 53,
                    height: 53,
                }],
            });

            google.maps.event.addListener(franceMarkerCluster, 'clusterclick', function (cluster) {
                var clusterMarkers = cluster.getMarkers();

                var offersList = '';
                var num = 0;

                for (i = 0; i < clusterMarkers.length; i++) {

                    num++;
                    var offerLabel = '<a class="offer-listing-link" href="' + clusterMarkers[i].link + '">' + clusterMarkers[i].getTitle() + '</a>';
                    offersList += offerLabel + '<br>';
                }

                infoWindow.setContent('<span class="offers-count">' + clusterMarkers.length + ' offres</span><br/>' + offersList);
                infoWindow.setPosition(cluster.getCenter());
                infoWindow.open(map);

            });

            // Build infoWindow on clusters
            google.maps.event.addListener(markerCluster, 'clusterclick', function (cluster) {

                var clusterMarkers = cluster.getMarkers();

                var offersList = '';
                var num = 0;

                for (i = 0; i < clusterMarkers.length; i++) {

                    num++;
                    var offerLabel = '<a class="offer-listing-link" href="' + clusterMarkers[i].link + '">' + clusterMarkers[i].getTitle() + '</a>';
                    offersList += offerLabel + '<br>';
                }


                if (map.getZoom() >= 14) {
                    infoWindow.setContent('<span class="offers-count">' + clusterMarkers.length + ' offres</span><br/>' + offersList);
                    infoWindow.setPosition(cluster.getCenter());
                    infoWindow.open(map);
                }

            });

            if (getUrlParameter('id_location').length > 0) {
                map.fitBounds(bounds);

            }
            var zoomOverride = map.getZoom();
            if (zoomOverride > 10)
                zoomOverride = 10;
            map.setZoom(zoomOverride);
        } else {
            // alert('Aucune offre trouvée');
        }


    }

    function createMarker(latlng, name, address, link) {
        var zip = "(" + address.split(" ").pop() + ")";
        address = address.substr(0, address.length - (zip.length - 2)) + zip;

        var html = '<div class="infowindow_content"><p class="infowindow_title">' + name + '</p>' + '<br/><div class="infowindow_line"><p class="infowindow_address"><span></span>' + address + '</p></div><br /><div class="infowindow_line"><p class="infowindow_link"><span></span><a href="' + link + '">En savoir plus</a></p></div></div>';

        var site_url = location.protocol + "//" + location.host;
        if (window.location.href.indexOf("/wordpress/") > -1) {
            site_url = location.protocol + "//" + location.host + "/wordpress";
        }

        if (address !== '(_default)' && address !== '(France)') {

            var marker = new google.maps.Marker({
                map: map,
                position: latlng,
                title: name,
                label: {
                    text: "1",
                    fontSize: "11px",
                    fontWeight: "bold"
                },
                link: link,
                icon: site_url + "/wp-content/themes/alpes-controles-child/www/images/google-maps/marker.png"
            });


            google.maps.event.addListener(marker, 'click', (function () {

                infoWindow.setContent(html);
                infoWindow.open(map, marker);

            }));

            markers.push(marker);

        } else {
            const franceMarker = new google.maps.Marker({
                map: map,
                position: latlng,
                title: name,
                link: link,
                icon: site_url + "/wp-content/themes/alpes-controles-child/www/images/google-maps/franceMarker1.png",
                styles: [{
                    url: site_url + "/wp-content/themes/alpes-controles-child/www/images/google-maps/franceMarker1.png",
                    textColor: "white",
                }],
            });

            franceMarkers.push(franceMarker);
        }
    }


    function searchLocations() {
        var address = document.getElementById('zipCodeInput').value;
        if (address === "" || address.length < 5) {
            return true;
        }

        geocoder.geocode({address: address, componentRestrictions: {'country': 'FR'}}, function (results, status) {
            if (status === google.maps.GeocoderStatus.OK) {
                // searchLocationsNear(results[0].geometry.location);
                zoomLocation(results[0].geometry.location);
            } else {
                if (!!$.prototype.fancybox)
                    $.fancybox.open([
                        {
                            type: 'inline',
                            autoScale: true,
                            minHeight: 30,
                            content: '<p class="fancybox-error">' + address + ' : Aucune offre trouvée</p>'
                        }
                    ], {
                        padding: 0
                    });
                else
                    alert(address + ' : Aucune offre trouvée');
            }
        });
    }

    function zoomLocation(position) {

        map.setCenter(position);
        map.setZoom(9);
    }

    function rad(x) {
        return x * Math.PI / 180;
    }


});
